module.exports.PdfElement = require('./pdf-element.js');
module.exports.PdfTextElement = require('./pdf-text-element.js');
module.exports.PdfTickBoxElement = require('./pdf-tick-box-element.js');
module.exports.PdfImageElement = require('./pdf-image-element.js');